/** Minimal history-based router (no dependency). */
import type { AnchorHTMLAttributes, MouseEvent } from 'react';
import { createStore, useStore } from './store';

const store = createStore({ path: window.location.pathname, search: window.location.search });
window.addEventListener('popstate', () => store.set({ path: window.location.pathname, search: window.location.search }));

export function navigate(to: string, opts: { replace?: boolean } = {}) {
  const url = new URL(to, window.location.origin);
  if (url.pathname + url.search === window.location.pathname + window.location.search) return;
  window.history[opts.replace ? 'replaceState' : 'pushState']({}, '', url.pathname + url.search);
  store.set({ path: url.pathname, search: url.search });
  window.scrollTo(0, 0);
}

export const usePath = () => useStore(store, (s) => s.path);
export const useSearch = () => useStore(store, (s) => s.search);

/** match('/trade/:symbol', '/trade/BTC') → { symbol: 'BTC' } */
export function match(pattern: string, path: string): Record<string, string> | null {
  const p = pattern.split('/').filter(Boolean);
  const s = path.split('/').filter(Boolean);
  if (p.length !== s.length) return null;
  const params: Record<string, string> = {};
  for (let i = 0; i < p.length; i++) {
    const a = p[i]!;
    const b = s[i]!;
    if (a.startsWith(':')) params[a.slice(1)] = decodeURIComponent(b);
    else if (a !== b) return null;
  }
  return params;
}

export function Link({ to, onClick, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement> & { to: string }) {
  return (
    <a
      href={to}
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        onClick?.(e);
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        if (rest.target && rest.target !== '_self') return; // let the browser open the new tab
        e.preventDefault();
        navigate(to);
      }}
      {...rest}
    />
  );
}
